import { useMemo } from 'react';
import { FormCheck } from 'react-bootstrap';
import { DescriptorsComponent } from '../../../../components/descriptor/descriptor.component';
import { CellProps } from '../../../../components/reports/generic-table/cell-prod.component';
import '../../../../components/reports/generic-table/cell-prod.component.scss';
import { IMAGES_REPO } from '../../../../static-resources';
interface ScenarioPlannerDetailsCellProps extends CellProps {
  showEditIconOnHover?: boolean;
  onRowEditClick?: (rowData: any) => void;
}

export const ScenarioPlannerDetailsCellProdComponent = ({
  data,
  showEditIconOnHover,
  onRowEditClick,
}: ScenarioPlannerDetailsCellProps) => {
  const { original } = data;
  const value = original.metadata ? original.metadata.description : '';
  const isModified = useMemo(() => {
    return (
      original?.isCrossElasticityModified ||
      original?.isMainElasticityModified ||
      original?.isStartingMetricModified
    );
  }, [original]);
  return (
    <div className="prod-cell-text">
      <div className="d-flex">
        <FormCheck
          checked={data.getIsSelected()}
          disabled={!data.getCanSelect()}
          onChange={data.getToggleSelectedHandler()}
        />
      </div>
      <div>
        <div>{value}</div>

        <DescriptorsComponent metadata={original?.metadata} />
      </div>
      <div
        className={`hover-edit-enabled ${isModified ? 'elasticity-modified' : ''}`}
      >
        {
          <div
            className="row-edit-icon"
            onClick={(e) => {
              e.stopPropagation();
              if (onRowEditClick) {
                onRowEditClick(original);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                if (onRowEditClick) {
                  onRowEditClick(original);
                }
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Edit row"
          >
            <img
              src={
                isModified ? IMAGES_REPO.EditOrangeIcon : IMAGES_REPO.EditIcon
              }
              alt="Edit"
              width="16"
              height="16"
            />
          </div>
        }
      </div>
    </div>
  );
};
